/** Shared across every admin page that displays a dollar amount (Products, Estimates, Budget), so
 * formatting never drifts between them. */
export function formatCurrency(n: number): string {
  return n.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
}

/** Whole-dollar variant for space-constrained rollup views (project header, task-card subtotals) —
 * itemized records (line items, individual estimates/invoices/payments) keep exact cents via
 * formatCurrency; only the summary views round. */
export function formatCurrencyRounded(n: number): string {
  return Math.round(n).toLocaleString('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });
}
